import styled from 'styled-components';
import {typographyStyles} from '../../../../utils/styles';

const StyledTransactionDetailsHeader = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledTransactionDetailsHeaderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 8px;
  width: 100%;

  a {
    align-items: center;
    border-radius: ${props => props.theme.border_radius.standard};
    color: ${props => props.theme.colors.neutral_10};
    display: flex;
    height: 36px;
    padding: 8px;
    transition: .2s;

    svg {
      path {
        fill: ${props => props.theme.colors.neutral_10};
      }
    }

    &:hover {
      background-color: ${props => props.theme.colors.neutral_2};
    }
  }
`;

const StyledTransactionDetailsHeaderDate = styled.span`
  ${typographyStyles.footnote.description};

  color: ${props => props.theme.colors.neutral_10};
  text-wrap: nowrap;
`;


const StyledTransactionDetailsHeaderPrice = styled.span`
  ${typographyStyles.heading.h4};

  &.returned {
    color: ${props => props.theme.colors.neutral_7};
    text-decoration: line-through;
  }
`;

const StyledTransactionDetailsHeaderTitle = styled.span`
  ${typographyStyles.heading.h5};

  color: ${props => props.theme.colors.neutral_10};
`;

export {
  StyledTransactionDetailsHeader,
  StyledTransactionDetailsHeaderDate,
  StyledTransactionDetailsHeaderPrice,
  StyledTransactionDetailsHeaderItem,
  StyledTransactionDetailsHeaderTitle
};
